let audioCtx;

export function playBeep() {
  try {
    if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const ctx = audioCtx;
    if (ctx.state === 'suspended') {
      ctx.resume?.();
    }
    const o = ctx.createOscillator();
    const g = ctx.createGain();

    o.type = 'sine';
    o.frequency.value = 880;
    g.gain.value = 0.001;

    o.connect(g);
    g.connect(ctx.destination);

    o.start();
    g.gain.exponentialRampToValueAtTime(0.2, ctx.currentTime + 0.01);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15);
    o.stop(ctx.currentTime + 0.16);
  } catch (e) {
    // ignore
  }
}

export async function ensureNotificationPermission() {
  try {
    if (!('Notification' in window)) return 'unsupported';
    if (Notification.permission === 'granted') return 'granted';
    if (Notification.permission === 'denied') return 'denied';
    const res = await Notification.requestPermission();
    return res;
  } catch (e) {
    return 'error';
  }
}

export function notifyIncoming({ title, body }) {
  try {
    if (!('Notification' in window)) return;
    if (Notification.permission !== 'granted') return;
    // eslint-disable-next-line no-new
    new Notification(title || 'New message', { body: body || '' });
  } catch (e) {
    // ignore
  }
}
